module.exports = "<ng-template #component></ng-template>"